import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "918989801088";
const WHATSAPP_MESSAGE = encodeURIComponent("Hi, I need support with Indorinama.");

const FloatingWhatsApp = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Indorinama on WhatsApp"
      className="fixed bottom-5 right-5 z-[120] flex items-center gap-3 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg transition-transform duration-200 hover:scale-[1.03] hover:bg-[#20ba5a] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
    >
      <FaWhatsapp className="text-[1.65rem]" />
      <span className="hidden text-sm font-semibold sm:inline">
        Chat now
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
